import Loader from './Loader';
import Snackbar from './Snackbar';

export default () => (
    <>
        <Loader />
        <Snackbar />
    </>
);
